import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutUsComponent } from './components/about/about-us/about-us.component';
import { HomeComponent } from './components/home/home/home.component';
import { UsLifeComponent } from './components/us-life/us-life/us-life.component';
import { MentorPageComponent } from './components/mentor/mentor-page/mentor-page.component';
import { CareerComponent } from './components/career/career/career.component';
import { CareerMainComponent } from './components/career/career-main/career-main.component';
import { CareerProjectsComponent } from './components/career/career-projects/career-projects.component';
import { EducationComponent } from './components/education/education/education.component';
import { ProjectsComponent } from './components/education/projects/projects.component';
import { EducationMainComponent } from './components/education/education-main/education-main.component';
import { JobsComponent } from './components/job/jobs/jobs.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'about_us', component: AboutUsComponent },
  { path: 'us_life', component: UsLifeComponent },
  { path: 'mentor', component: MentorPageComponent },
  { path: 'jobs', component: JobsComponent },
  {
    path: 'career',
    component: CareerComponent,
    children: [
      { path: '', component: CareerMainComponent },
      { path: 'intern', component: CareerProjectsComponent },
      { path: 'full-time', component: CareerProjectsComponent },
      { path: 'enterprise', component: CareerProjectsComponent },
      { path: 'interview', component: CareerProjectsComponent },
      { path: 'vip', component: CareerProjectsComponent },
    ]
  },
  {
    path: 'education',
    component: EducationComponent,
    children: [
      { path: '', component: EducationMainComponent },
      { path: 'liberalArt', component: ProjectsComponent },
      { path: 'science', component: ProjectsComponent },
      { path: 'engineering', component: ProjectsComponent },
      { path: 'business', component: ProjectsComponent },
      { path: 'art', component: ProjectsComponent },
    ]
  },
  // { path: 'education/:id', component: ProjectsComponent },
  { path: '**', redirectTo: '/home', pathMatch: 'full' }
];

@NgModule({

  // Use RouterModule.forRoot with the {useHash: true} argument. To avoid refresh 404
  imports: [ RouterModule.forRoot(routes, { useHash: true }), RouterModule.forChild(routes)],
  // imports: [ RouterModule.forRoot(routes)],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/app-routing.module.ts